/// <reference path="../app.ts" />
namespace Cfnc {
    export class Escape {
        static filterId: string = "escape";

        static filter() {
            return function (input: string) {
                return encodeURIComponent(input);
            }
        }
    }
    angular.module("app").filter(Escape.filterId, [Escape.filter]);
}